export default {
  en: {
    'components.filing-types-form.filing-start-date.label': 'Filing Start Date',
    'components.filing-types-form.filing-start-date.required':
      'Please enter a valid filing start date',

    'components.filing-types-form.filing-type.label': 'Filing Type',
    'components.filing-types-form.filing-type.required': 'Please select a filing type',

    'components.filing-types-form.submission-period.label': 'Submission Period',
    'components.filing-types-form.submission-period.required': 'Please select a submission period',

    'components.filing-types-form.day-due.label': 'Day Due',
    'components.filing-types-form.day-due.required': 'Please select a due day',

    'components.filing-types-form.periodicity.label': 'Periodicity',
    'components.filing-types-form.periodicity.required': 'Please select periodicity',

    'components.filing-types-form.user-experience.label': 'Experience',
    'components.filing-types-form.user-experience.required': 'Please select a user experience',

    'components.filing-types-form.action.submit': 'Save',
    'components.filing-types-form.action.cancel': 'Cancel',

    'components.filing-types-form.modify-confirmation.message':
      'Please note, by modifying this filing type you will remove any existing Due Filing opportunities for this country.',

    'components.filing-types-form.no-results.description':
      'No additional filing types available for this registration.',
    'components.filing-types-form.no-results.title': 'No Filing Types',
  },
};
